import ApiService from "@/_services/api/api.service";
import appConfig from "@/app-config";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const WorkOrderService = {
  dataSourceConfig(url, params) {
    return ApiService.createDataSource(url, params);
  },

  async getByCode(code) {
    const requestScreenData = {
      url: "api/WorkOrder",
      top: "1",
      filter: `Code eq ${code}`,
      select:
        "Code,QuoteCode,BomCode,ShipDate,ScheduledDate,ItemQty,DivisionCode,BranchCode,Comment,ProductCode,CreatedBy,DateCreated,ChangedBy,DateChanged,FriendlyStatus,MTSQuantity,SalesOrderStockUMQuantity,ActualQty",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async save(payload) {
    const url = "api/Save_WorkOrder";

    return await ApiService.post(url, payload);
  },

  async completeWorkOrder(payload) {
    const url = "api/WorkOrder/Complete";

    return await ApiService.post(url, payload);
  },

  async reopenWorkOrder(payload) {
    const url = "api/WorkOrder/ReOpen";

    return await ApiService.post(url, payload);
  },

  async cancelWorkOrder(payload) {
    const url = "api/WorkOrder/Cancel";

    return await ApiService.post(url, payload);
  },
  async getProductDataForAddInDataSource(productCode, branchCode) {
    const requestScreenData = {
      url: "api/WorkOrderAddInItemCompanyBranch",
      filter: `ItemCode eq '${productCode}' and BranchCode eq '${branchCode}' and IsDefault eq 'Y'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async workOrderReschedule(payload) {
    const url = "api/Save_WorkOrderReschedule";

    return await ApiService.post(url, payload);
  },
  async getWorkOrderAddIns(workOrderCode) {
    const requestScreenData = {
      url: "api/WorkOrderAddInList",
      filter: `WorkOrderCode eq ${workOrderCode}`,
      orderby: "DateCreated asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },
  async getWOSOLines(WOCode) {
    const requestScreenData = {
      url: "api/WorkOrderToSalesOrderLineList",
      filter: `WorkOrderCode eq ${WOCode}`,
      orderby: "PackDate asc,Position asc",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderMaterialList(WOCode) {
    try {
      const requestScreenData = {
        url: "api/WorkOrderMaterial",
        filter: `WorkOrderCode eq ${WOCode} and IssueType eq 'Material'`,
      };

      return await ApiService.oDataGet(requestScreenData);
    } catch (e) {
      return null;
    }
  },

  async getBomUnitOfMeasure(code) {
    const requestScreenData = {
      url: "api/BomUnitOfMeasure",
      filter: `BomCode eq '${code}' and IsDefault eq 'Y'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getBOMByCode(code) {
    const requestScreenData = {
      url: "api/Bom",
      top: "1",
      filter: `Code eq '${code}'`,
      select:
        "Code,Comment,Description1,Description2,ProductCode,BatchSize,BranchCode,DivisionCode,BomTypeCode,Status",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async reOrderWorkOrder(payload) {
    const url = "api/WorkOrder/ReorderProcessWorkOrderSequence";

    return await ApiService.post(url, payload);
  },

  async getWorkOrderSalesOrderDetailLine(SalesOrderCode, SalesOrderLine) {
    const requestScreenData = {
      url: "api/PickingSlipDetail",
      top: 1,
      filter: `SalesOrderCode eq ${SalesOrderCode} and LineNo eq ${SalesOrderLine}`,
      select: "SalesOrderCode,LineNo,SalesUMBackorderQty,StockUMBackorderQty",
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getWorkOrderSalesOrderLines(filter) {
    const requestScreenData = {
      url: "api/WorkOrderSalesOrderDetailLineList",
      filter: filter,
    };

    return await ApiService.oDataGet(requestScreenData);

  },

  async getBOMByProductCode(code) {
    const requestScreenData = {
      url: "api/Bom",
      top: "1",
      filter: `ProductCode eq '${code}'`,
      select: [
        "Code",
        "Comment",
        "Description1",
        "Description2",
        "ProductCode",
        "BatchSize",
        "BranchCode",
        "DivisionCode",
        "BomTypeCode",
        "Status",
      ]
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export { WorkOrderService };
